import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { createAppVersion } from '../../graphql/mutation';
import { 
  Card, 
  Form, 
  Input, 
  Button, 
  Space, 
  Row, 
  Col,
  Switch
} from 'antd';
import { showSnackBar } from '../../components/SnackBar/SnackBar';
import './CreateAppVersion.css';

const CreateAppVersion = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [createAppVersionMutation] = useMutation(createAppVersion);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      await createAppVersionMutation({
        variables: {
          version: values.version,
          reviewMode: values.reviewMode || false
        }
      });

      showSnackBar('success', 'Success', 'App version created successfully');
      navigate('/app-versions');
    } catch (error) {
      showSnackBar('error', 'Error', error.message || 'Failed to create app version');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-app-version-container">
      <Card title="Create App Version">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ reviewMode: false }}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="version"
                label="Version"
                rules={[{ required: true, message: 'Please enter version' }]}
              >
                <Input placeholder="Enter version (e.g., 1.0.0)" />
              </Form.Item>

              <Form.Item
                name="reviewMode"
                label="Review Mode"
                valuePropName="checked"
                tooltip="Enable this if the app version is under review (e.g., App Store review)"
              >
                <Switch 
                  checkedChildren="Review" 
                  unCheckedChildren="Normal"
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Create App Version
              </Button>
              <Button onClick={() => navigate('/app-versions')}>
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateAppVersion;
